import request from '../utils/request'
import axios from 'axios'

export function buscarEndereco (cep) {
  return axios.get('https://viacep.com.br/ws/' + cep + '/json/')
}

export function downloadFile (param) {
  return request({
    url: '/report/' + param,
    method: 'get',
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/services/appservice.js